import { createApiIdentityPlugin } from "zudoku/plugins";
import { getToken, getApiBaseUrl, type ApiEnvironment } from "./tokenStorage";

interface MeResponse {
  user: { email: string };
}

const ENV_LABELS: Record<ApiEnvironment, string> = {
  dev: "Development",
  cloud: "Production",
};

async function fetchUserEmail(
  env: ApiEnvironment,
  token: string
): Promise<string | null> {
  try {
    const baseUrl = getApiBaseUrl(env);
    const response = await fetch(`${baseUrl}/v1/me`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    if (!response.ok) return null;
    const data: MeResponse = await response.json();
    return data.user?.email || null;
  } catch {
    return null;
  }
}

export const backofficeIdentityPlugin = createApiIdentityPlugin({
  getIdentities: async () => {
    const identities = [];

    for (const env of ["dev", "cloud"] as ApiEnvironment[]) {
      const token = getToken(env);
      if (!token) continue;

      // Tokens are pre-validated on save, so email should always be available
      const email = await fetchUserEmail(env, token);
      if (!email) continue; // Skip invalid tokens

      identities.push({
        id: `pat-${env}`,
        label: `PAT: ${email} (${ENV_LABELS[env]})`,
        authorizeRequest: (request: Request) => {
          request.headers.set("Authorization", `Bearer ${token}`);
          return request;
        },
        authorizationFields: {
          headers: ["Authorization"],
        },
      });
    }

    return identities;
  },
});
